import React from 'react';

const LazyRodeoEventLeaderBoard = React.lazy(() =>
    import('./leaderboard')
);

const LeaderBoard = (props: Record<string, any>) => (
    <React.Suspense fallback={<h1>Loading...</h1>}>
        <LazyRodeoEventLeaderBoard {...props} />
    </React.Suspense>
);

export default LeaderBoard